<template>  
  <modal v-model="show"
          max-width="400"
          :has-padding="false">          
    <button class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="reset()">
     {{$t('message.api.message.registerApi')}}
    </button>

    <div>
      <form @submit.prevent="submit">
        <div class="form-body">
          <h1 class="text-muted text-center">
              {{$t('message.api.message.newApi')}}
          </h1>
          <h4 class="text-muted text-center">
              {{$t('message.api.message.apiRegistration')}}
          </h4>
          <v-text-field v-model="form.name"
                        v-validate="'required'"
                        :label="$t('message.generics.message.name')"
                        name="Nome"
                        :error-messages="errors.collect($t('message.generics.message.name'))"></v-text-field>
        </div>

        <div class="card-footer">
          <button class="btn btn-primary btn-round">
              {{$t('message.api.message.conclude')}}
          </button>
        </div>
      </form>

    </div>
  </modal>  
</template>

<script>
    import dataEntityProp from '@mixins/data-entity-prop'
    import Modal from "@/components/generic/Modal";


    export default {
        components: {
          Modal
        },

        data() {
            return {
              show: false,
              form: {
                name: ''
              },
              copyAction: {
                label: this.$t('message.generics.message.copy'),
                icon: 'mdi-content-copy'
              }
            }
        },

        props: {
            user: {
                type: Object
            }
        },

        mixins: [dataEntityProp],

        methods: {
          reset() {
            this.form.name = ''
          },
          async submit() {
            const isValid = await this.$validator.validateAll()

            if(isValid) {
              try {
                await this.$api.apis.register({
                  name: this.form.name
                });

                this.show = false;


                this.$emit('registered')
              } catch (error) {
                console.log(error);
              }
            }
          },
        },
    }
</script>

<style lang="scss" scoped>
.form-body {
  padding: 18px 50px 10px;

  h1 {
    font-weight: 600;
  }
}

.btn {
  margin-right: 10px;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.modal-round .v-card .card-body {
  min-height: 160px;
}
</style>
